import { TextField } from '@material-ui/core';
import React, { FC, memo, useCallback } from 'react';

const noop = () => undefined;

const selectProps = { native: true };

interface Props {
  label?: string;
  selectedId: string | undefined;
  options: { id: string; label: string }[];
  onChange?: (id: string | undefined) => void;
  fullWidth?: boolean;
  margin?: 'none' | 'dense' | 'normal';
  autoFocus?: boolean;
  disabled?: boolean;
  required?: boolean;
  helperText?: string;
  error?: boolean;
  useEmptyLabel?: boolean;
}

export const MuiSelect: FC<Props> = memo(
  ({
    label,
    selectedId,
    options,
    onChange = noop,
    fullWidth = true,
    margin,
    autoFocus,
    disabled,
    required,
    helperText,
    error = false,
    useEmptyLabel = false
  }: Readonly<Props>) => {
    const onChangeNative = useCallback(
      (ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        onChange(ev.target.value === '' ? undefined : ev.target.value);
      },
      [onChange]
    );

    return (
      <TextField
        select
        label={label}
        value={selectedId}
        onChange={onChangeNative}
        SelectProps={selectProps}
        helperText={helperText}
        margin={margin}
        disabled={disabled}
        required={required}
        autoFocus={autoFocus}
        error={error}
        fullWidth={fullWidth}
      >
        {useEmptyLabel ? <option value='' /> : undefined}
        {options.map(opt => (
          <option key={opt.id} value={opt.id}>
            {opt.label}
          </option>
        ))}
      </TextField>
    );
  }
);

MuiSelect.displayName = 'MuiSelect';
